import './vendor/modernizr';
import { AnimateObserver } from './lib/animate-observer';
import Alpine from 'alpinejs'
import { Accordion } from './lib/accordion';
import { Counter } from './lib/counter';
import collapse from '@alpinejs/collapse'
import intersect from '@alpinejs/intersect'
import { Menu } from './lib/menu';
// import { Consent } from './lib/consent';
import { Sticky } from './lib/sticky';
// import { Fancybox } from '@fancyapps/ui';

window.Accordion = Accordion;
window.Menu = Menu;
window.Counter = Counter;
window.Alpine = Alpine

Alpine.plugin(collapse)
Alpine.plugin(intersect)
Alpine.start()

// Fancybox.bind('[data-fancybox]');

const animate = new AnimateObserver();
animate.init();

// const consent = new Consent();
// consent.init();

const sticky = new Sticky();
sticky.init();

if ( document.querySelector( '.js-carousel' ) ) {
    import('./lib/carousel').then( module => {
        const carousel = new module.Carousel();
        carousel.init();
    });
}

if ( document.querySelector( '.js-map' ) ) {
    import('./lib/map').then( module => {
        const map = new module.Map();
        map.init();
    } );
}

import('./lib/turnstile').then( module => {
    const turnstile = new module.Turnstile();
    if(turnstile) {
        turnstile.init()
    }
    window.onloadTurnstileCallback = function() {
        turnstile.init()
    }
} );

if ( window.location.href.indexOf( 'q' ) > -1 ) {
    window.addEventListener( 'load', () => {
        document.querySelector( '#insights' ).scrollIntoView( {
            behavior: 'smooth'
        } );
    } );
}
